import { localApi } from "./localApi";

/**
 * Registre des plateformes (couleur, encaissement) — réglage agence stocké dans
 * tenant-settings kind=platforms (property_id "_"), mis en cache localStorage.
 * Les plateformes intégrées peuvent être surchargées ; les autres sont libres.
 */
const LS_KEY = "casaneo_platforms";

export const BUILTIN_PLATFORMS = [
  { key: "airbnb",  name: "Airbnb",         rateKey: "Airbnb",      color: "#FF5A5F", collection: "platform", match: /airbnb/ },
  { key: "booking", name: "Booking.com",    rateKey: "Booking.com", color: "#003580", collection: "agency",   match: /booking/ },
  { key: "vrbo",    name: "Vrbo / Abritel", rateKey: "Vrbo",        color: "#3B82F6", collection: "platform", match: /vrbo|abritel|homeaway/ },
  { key: "expedia", name: "Expedia",        rateKey: "Expedia",     color: "#FFC72C", collection: "agency",   match: /expedia|hotels\.com/ },
  { key: "amivac",  name: "Amivac",         rateKey: "Amivac",      color: "#EAB308", collection: "agency",   match: /amivac/ },
  { key: "google",  name: "Google Vacation Rentals", rateKey: "Google", color: "#34A853", collection: "agency", match: /google/ },
  { key: "hozy",    name: "Hozy",           rateKey: "Hozy",        color: "#F97316", collection: "platform", match: /hozy/ },
  { key: "holidu",  name: "Holidu",         rateKey: "Holidu",      color: "#7C3AED", collection: "platform", match: /holidu/ },
  { key: "direct",  name: "Direct",         rateKey: "Direct",      color: "#059669", collection: "agency",   match: /direct/ },
];

export const slugify = (s = "") => String(s).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

let registry = null;
const listeners = new Set();

function load() {
  if (registry) return registry;
  try { registry = JSON.parse(localStorage.getItem(LS_KEY) || "[]"); } catch { registry = []; }
  if (!Array.isArray(registry)) registry = [];
  return registry;
}

/** Plateformes personnalisées + surcharges des intégrées : [{key, name, color, collection, builtin}] */
export function getPlatforms() {
  return load();
}

export function setPlatforms(items, { persist = true } = {}) {
  registry = (items || []).map((p) => ({ ...p, key: p.key || slugify(p.name) })).filter((p) => p.key);
  try { localStorage.setItem(LS_KEY, JSON.stringify(registry)); } catch { /* quota */ }
  listeners.forEach((fn) => fn(registry));
  if (!persist) return Promise.resolve(true);
  return localApi.put("/tenant-settings/platforms/_", { data: { items: registry } }).then(() => true).catch(() => false);
}

export function subscribePlatforms(fn) { listeners.add(fn); return () => listeners.delete(fn); }

/** Fiche d'une plateforme depuis un libellé brut (résa.platform) : surcharge agence > intégrée > null. */
export function platformInfo(raw = "") {
  const k = String(raw || "").toLowerCase().trim();
  const custom = load().find((p) => p.key === slugify(k) || (p.name && k && k.includes(p.name.toLowerCase())));
  const builtin = BUILTIN_PLATFORMS.find((b) => b.match.test(k) || (!k && b.key === "direct"));
  if (custom) return { ...(builtin || {}), ...custom, builtin: !!builtin };
  return builtin ? { ...builtin, builtin: true } : null;
}

/** Liste complète pour les écrans (intégrées fusionnées avec les surcharges + personnalisées). */
export function allPlatforms() {
  const custom = load();
  const merged = BUILTIN_PLATFORMS.map((b) => ({ ...b, builtin: true, ...(custom.find((c) => c.key === b.key) || {}) }));
  return [...merged, ...custom.filter((c) => !BUILTIN_PLATFORMS.some((b) => b.key === c.key)).map((c) => ({ ...c, builtin: false }))];
}
